import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    release: import.meta.env.VITE_APP_VERSION,
    environment: import.meta.env.VITE_APP_ENV,
    sampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE,
    tracesSampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE,
    allowUrls: [new RegExp(import.meta.env.VITE_SENTRY_ALLOW_URL)],
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.thirdPartyErrorFilterIntegration({
            filterKeys: ['phoenix-fo-js'],
            behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
        }),
    ],
    beforeSend(event) {
        // Mark third-party frames as not in-app
        event.exception?.values?.forEach((exception) => {
            exception.stacktrace?.frames?.forEach((frame) => {
                if (frame.filename && !/letudiant\.fr/.test(frame.filename)) {
                    frame.in_app = false;
                }
            });
        });

        const frames = event.exception?.values?.flatMap(
            (value) => value.stacktrace?.frames ?? [],
        ) ?? [];

        // Drop errors with no stack trace (cross-origin script errors)
        if (frames.length === 0) {
            return null;
        }

        // Drop if no frame is from our own bundle
        if (frames.every((frame) => !frame.in_app)) {
            return null;
        }

        return event;
    },
});
